<template>
    <v-tooltip v-if="tooltip" :text="tooltip" location="top">
        <template #activator="{ props }">
            <v-chip
                v-bind="props"
                :color="statusColor"
                size="small"
                variant="flat"
            >
                {{ statusLabel }}
            </v-chip>
        </template>
    </v-tooltip>
    <v-chip
        v-else
        :color="statusColor"
        size="small"
        variant="flat"
    >
        {{ statusLabel }}
    </v-chip>
</template>

<script>
export default {
    props: {
        status: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            default: "",
        },
    },
    computed: {
        statusLabel() {
            const key = `reservationStatus.${this.status}`;
            return this.$te(key) ? this.$t(key) : this.status;
        },
        statusColor() {
            const colors = {
                pending: "warning",
                waiting_for_to: "info",
                waiting_for_signed_to: "info",
                waiting_for_confirmation: "info",
                confirmed: "success",
                in_progress: "success",
                completed_and_awaiting_confirmation: "success",
                completed_and_confirmed: "success",
                declined: "error",
            };
            return colors[this.status] || "default";
        },
    },
};
</script>
